import React from 'react';
import PropTypes from 'prop-types';

function MirCardIcon({ className }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="24"
      viewBox="0 0 34 24"
      className={className}
    >
      <defs>
        <linearGradient id="mirA" x1="-.18%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="#00B4E6" />
          <stop offset="100%" stopColor="#088CCB" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <rect width="33" height="23" x=".5" y=".5" fill="#FFF" stroke="#E1E1E1" rx="3" />
        <path
          fill="url(#mirA)"
          d="M24.86 0h-5.32c.29 1.77 2 3.43 3.89 3.43h4.23c.05-.17.05-.4.05-.57A2.83 2.83 0 0 0 24.86 0z"
          transform="translate(3 8)"
        />
        <path
          fill="#4DB45F"
          d="M23 11.71V16h2.57v-2.29h2.29a2.83 2.83 0 0 0 2.68-2H23zM13.86 8v8h2.28s.57 0 .86-.57l2-4h.29V16h2.57V8h-2.29s-.57.06-.86.57l-2 4h-.28V8h-2.57zM3 16V8h2.57s.74 0 1.14 1.14c1.03 3.03 1.15 3.43 1.15 3.43s.23-.74 1.14-3.43C9.4 8 10.14 8 10.14 8h2.57v8h-2.57v-4.29h-.28L8.43 16H7.29l-1.43-4.29h-.29V16H3z"
        />
      </g>
    </svg>
  );
}

MirCardIcon.propTypes = {
  className: PropTypes.string,
};

export default MirCardIcon;
